export const SHOP = {
    name: "Yuhuku Kopi",
    tagline: "Coffee shop based in Bandar Lampung",
    address: "Perum Raffles Residence Blok C3-04, Bandar Lampung",
    hours: "Setiap hari, 11.00–21.00",
    whatsapp: "https://wa.me/6281929550751",
    whatsappDisplay: "+62 819-2955-0751",
    instagram: "https://instagram.com/yuhuku.kopi",
    instagramHandle: "@yuhuku.kopi",
    gofood: "https://gofood.link/a/QHzqxaJ",
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=Yuhuku+Kopi+Perum+Raffles+Residence+Bandar+Lampung",
    mapsEmbed:
        "https://maps.google.com/maps?q=Yuhuku%20Kopi%20Perum%20Raffles%20Residence%20Bandar%20Lampung&t=&z=16&ie=UTF8&iwloc=&output=embed",
};

export const IMG = {
    hero: "/photos/hero.jpg",
    shopInterior: "/photos/shop-interior.jpg",
    shopExterior: "/photos/shop-exterior.jpg",
    signature: "/photos/coffee-cup.jpg",
    matcha: "/photos/matcha.jpg",
    bottled: "/photos/bottles.jpg",
    dispensers: "/photos/dispensers.jpg",
    coffeeCat: "/photos/coffee-cup.jpg",
    matchaGlass: "/photos/matcha.jpg",
};

export const MENU = [
    {
        id: "coffee",
        label: "Coffee",
        note: "Espresso-based klasik, hot atau iced",
        image: IMG.coffeeCat,
        groups: [
            {
                title: "Coffee",
                items: [
                    { name: "Signature", note: "coconut & palm sugar", price: "15K", best: true },
                    { name: "Arena", note: "palm sugar", price: "15K" },
                    { name: "Salma", note: "salted caramel", price: "17K" },
                    { name: "Kama", note: "caramel", price: "17K" },
                    { name: "Latte", note: "hot / iced", price: "17K" },
                    { name: "Butterscotch", note: "", price: "20K" },
                    { name: "Phio", note: "pistachio", price: "20K" },
                    { name: "Americano", note: "hot / iced", price: "13K" },
                    { name: "Peachycano", note: "", price: "17K" },
                    { name: "Berrycano", note: "", price: "17K" },
                    { name: "Mont Blanc", note: "", price: "22K" },
                ],
            },
        ],
    },
    {
        id: "non-coffee",
        label: "Non Coffee",
        note: "Buat yang nggak ngopi, tetap punya tempat",
        image: IMG.matchaGlass,
        groups: [
            {
                title: "Non Coffee",
                items: [
                    { name: "Matcha Latte", note: "", price: "23K", best: true },
                    { name: "Matcha Cloud", note: "", price: "26K" },
                    { name: "Matcha Oat", note: "", price: "26K" },
                    { name: "Red Velvet", note: "", price: "20K" },
                    { name: "Chocolate", note: "", price: "20K" },
                ],
            },
        ],
        extras: [
            { name: "Espresso tambahan", price: "5K" },
            { name: "Salted Cream", price: "5K" },
        ],
    },
    {
        id: "snacks",
        label: "Snacks",
        note: "Teman setia ngopi, digoreng dadakan",
        image: null,
        groups: [
            {
                title: "Snacks",
                items: [
                    { name: "French Fries", note: "", price: "15K" },
                    { name: "Indomie Telur", note: "", price: "13K" },
                    { name: "Indomie Double", note: "", price: "18K" },
                    { name: "Omelet Mie", note: "", price: "15K" },
                    { name: "Rujak Cireng", note: "", price: "18K" },
                    { name: "Mix Platter", note: "", price: "25K" },
                    { name: "Chicken Burger", note: "", price: "20K" },
                    { name: "Pempek", note: "isi 5 pcs", price: "17K" },
                ],
            },
        ],
    },
    {
        id: "bottled",
        label: "Bottled",
        note: "Bawa pulang, simpan dingin",
        image: IMG.bottled,
        groups: [
            {
                title: "Botol 250 ml",
                items: [
                    { name: "Signa", note: "", price: "22K" },
                    { name: "Arena", note: "", price: "22K" },
                    { name: "Matcha", note: "", price: "42K" },
                    { name: "Choco", note: "", price: "32K" },
                    { name: "RedVelvet", note: "", price: "33K" },
                ],
            },
            {
                title: "Seliter — buat 6–7 porsi",
                items: [
                    { name: "Seliter Signature", note: "", price: "75K" },
                    { name: "Seliter Arena", note: "", price: "75K" },
                    { name: "Seliter Matcha", note: "", price: "125K" },
                    { name: "Seliter Chocolate", note: "", price: "115K" },
                    { name: "Seliter RedVelvet", note: "", price: "115K" },
                ],
            },
        ],
    },
];

export const FAVORITES = [
    {
        name: "Signature",
        note: "espresso, coconut & palm sugar — yang paling dicari",
        price: "15K",
        image: IMG.signature,
    },
    {
        name: "Matcha Latte",
        note: "matcha premium, creamy dan seimbang",
        price: "23K",
        image: IMG.matcha,
    },
    {
        name: "Seliter Matcha",
        note: "botol 1 liter untuk 6–7 porsi, buat dibagi",
        price: "125K",
        image: IMG.dispensers,
    },
];

export const MARQUEE_ITEMS = [
    "Signature 15K",
    "Matcha Latte 23K",
    "Arena 15K",
    "Butterscotch 20K",
    "Americano 13K",
    "Rujak Cireng 18K",
    "Seliter Matcha 125K",
    "Chicken Burger 20K",
];
